module.exports = __webpack_public_path__ + "img/mobile_3.05a91d2e.jpg";